export default __webpack_public_path__ + "static/media/app_Store_badge.61ef03a4.png";